import { oz } from '@weft/utils';
import { DEFAULT_PAGE_NUMBER } from '../../utils';

export const PageNumberSchema = oz.coerce.number().default(DEFAULT_PAGE_NUMBER);